<template>
	<div>
		<div class="fw7 fs5 lh150">Do you want to issue this policy?</div>
		<div class="lh125">
			This policy will become an issued policy. This action can't be reverted.
		</div>
		<div class="mt4">
			<j-button :isLoading="isLoading" @click="issuePolicy">
				Issue Policy
			</j-button>
		</div>
	</div>
</template>

<script>
import JButton from "@/components/JButton"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JButton },

	props: {
		policyId: {
			type: String
		}
	},

	data() {
		return {
			isLoading: false
		}
	},

	methods: {
		async issuePolicy() {
			const query = gql`
				mutation issuePolicy($policyId: String!, $isManual: Boolean) {
					issuePolicy(policyId: $policyId, isManual: $isManual) {
						errors
						status
						policyStatus {
							id
							status
						}
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: { policyId: this.policyId, isManual: true }
			})
			this.isLoading = false

			// Check errors
			if (res?.data?.issuePolicy?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.issuePolicy?.errors?.[0] ||
						res?.errors?.[0]?.message ||
						this.$t("errors.general")
				)
				return
			}

			this.$emit("done")
		}
	}
}
</script>
